import { StyleSheet } from 'aphrodite';
import { Input } from '../../../web/components-v2/Input';
import { ChangeEventHandler } from 'react';
import * as React from 'react';

const s = StyleSheet.create({
	input: {
		minWidth: 120,
	},
});

interface IProps {
	className?: string;
	handler: ChangeEventHandler;
	id: string;
	label?: JSX.Element;
	value: string;
}

export const InputField: React.FC<IProps> = ({ className = '', handler, id, label, value }) => {
	return (
		<div className={className}>
			<label htmlFor={id}>{label}</label>
			<Input id={id} onChange={handler} type='text' value={`${value || ''}`} styles={[s.input]} />
		</div>
	);
};
